module.exports = __webpack_public_path__ + "svg/new-cup-small.79cd3b7b12a81474eb1ff58f8324af22.svg";